import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import EventPageInfo from "../../components/EventPageInfo.jsx";
import AdditionalInfo from "../../components/AdditionalInfo.jsx";
import MoreInfo from "../../components/MoreInfo.jsx";
import OrganizerCard from "../../components/OrganizerCard.jsx";
import CancellationPolicyBanner from "../../components/CancellationPolicyBanner.jsx";
import "react-loading-skeleton/dist/skeleton.css";
import { endpoints } from "../../utils/Constants.js";
import {
  destroyModal,
  renderBookingPanelLinks,
  eventGroupCode,
  nodeAliasPath,
} from "../../utils/Utils.js";
import { mutateEventPropsData } from "../../utils/Mutates.js";

const EventApp = () => {
  const [eventProps, setEventProps] = useState([]);
  const [hasEventEnded, setHasEventEnded] = useState(false);
  const [loading, setLoading] = useState(true);

  const [organizers, setOrganizers] = useState([]);
  const [organizersLoading, setOrganizersLoading] = useState(true);

  const [media, setMedia] = useState([]);
  const [mediaLoading, setMediaLoading] = useState(true);

  useEffect(() => {
    //hides mini cancellation i icons
    $("[id*=cancellationPolicyDiv]").hide();
    fetchData();
  }, []);

  useEffect(() => {
    if (eventProps?.events && !eventProps.hasSameInfoData) {
      renderBookingPanelLinks();
      setBookingPanelLinks(eventProps?.events);
    }
  }, [eventProps]);

  const fetchData = () => {
    const code = encodeURIComponent(eventGroupCode());
    fetch(endpoints.event.getMedia, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        nodealiaspath: encodeURIComponent(nodeAliasPath()),
      }),
    })
      .then((mediaResponse) => mediaResponse.json())
      .then((media) => {
        setMedia(media);
        setMediaLoading(false);
      })
      .catch((error) => {
        console.error(`Can't fetch media!`, error);
        setMediaLoading(false);
      });
    fetch(`${endpoints.event.getEvents}?eventGroupCode=${code}`)
      .then((response) => {
        if (response.status === 204) {
          setHasEventEnded(true);
          $(".event-ended").css({
            margin: "16px 16px 24px 16px",
            "border-radius": "10px",
          });
          $(".cf").css({ "box-shadow": "0px 0px 85px rgb(0 0 0 / 7%)" });
        }
        return response.json();
      })
      .then((eventProps) => {
        setEventProps(mutateEventPropsData(eventProps));
        setHasEventEnded(false);
        setLoading(false);
      })
      .catch((error) => {
        console.error(`Can't fetch event dates!`, error);
        setLoading(false);
      });
    fetch(endpoints.event.getProducers, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
        body: JSON.stringify({
            eventGroupCode: eventGroupCode(),
            producerId:null
        }),
    })
      .then((result) => result.json())
      .then(
        (data) => {
          setOrganizers(data);
          setOrganizersLoading(false);
        },
        (error) => {
          console.log("cant fetch organizers", error);
          setOrganizersLoading(false);
        }
      );
  };

  const setBookingPanelLinks = (eventProps) => {
    $(".moreInfo").on("click", function () {
      let link = $("<div id='modal'></div>");
      let eventId = $(this).data("eventid");
        $(this).append(link);
      renderModal(eventId, eventProps);
    });
  };

  const renderModal = (eventId, eventProps) => {
      const eventProp = eventProps.find((p) => p.eventId === eventId);
      const moreInfoLink = document.querySelector(`[data-eventid='${eventId}']`);
      const modal = moreInfoLink.querySelector("#modal");
    ReactDOM.render(
      <MoreInfo
        destroyModal={destroyModal("#modal")}
        eventId={eventId}
        eventProp={eventProp}
        key={eventId}
        loading={loading}
        />,
      modal
    );
  };

  return (
    <>
      <EventPageInfo
        showModals={!eventProps?.hasSameInfoData}
        nullAdditionalInfo={eventProps?.nullAdditionalInfo}
        producerCount={eventProps?.producerCount}
        hasEventEnded={hasEventEnded}
        media={media}
        mediaLoading={mediaLoading}
        venueSeatsProp={eventProps?.venueSeatsProp}
        lat={
          eventProps?.additionalInfoData &&
          eventProps?.additionalInfoData.venueLatitude
        }
        long={
          eventProps?.additionalInfoData &&
          eventProps?.additionalInfoData.venueLongitude
        }
      />

      <AdditionalInfo
        hasAdditionalInfoSection={
          eventProps?.hasAdditionalInfoSection && !hasEventEnded
        }
        eventData={eventProps?.events && eventProps?.additionalInfoData}
        loading={loading}
      />

      <CancellationPolicyBanner
        loading={loading}
        multiplePolicies={eventProps?.multipleCancellationPolicies}
        hasCancellationPolicySection={eventProps?.hasCancellationPolicySection}
        allowCancel={eventProps?.allowCancelProp}
        allowUpdate={eventProps?.allowUpdateProp}
        producerName={eventProps?.producerNameProp}
      />

      <OrganizerCard loading={organizersLoading} organizers={organizers} />
    </>
  );
};

export default EventApp;
